<template>
    <el-popover
    placement="bottom-end"
    width="756"
    trigger="click"
    v-model="showController"
    >
        <div class="con">
            <i 
                class="btn-close el-icon-close"
                @click="showController = false"
            ></i>

            <div class="right">
                <div 
                v-if="!addController"
                class="center"
                >
                    <div class="warn-text" v-if="noFollowController">
                        <span class="warn">
                            该账号未绑定微信
                        </span>
                        ，请扫码关注惠招标微信公众号，左下角
                        <span class="warn">
                            “惠工作-平台登录”
                        </span>
                        ，成功登录即微信绑定成功
                    </div>

                    <div class="qrcode">
                        <img :src="qrUrl" alt="">
                    </div>

                    <div class="qr-text">
                        关注{{title}}微信公众号
                        <br/>
                        提醒内容将通过微信公众号发给您！
                    </div>
                </div>

                <form-add
                    v-if="addController"
                    class="center"
                    @close="addController = false"
                    @add="queryData"
                    @notfollow="addController=false,noFollowController=true"
                ></form-add>
            </div>

            <div class="left">
                <div class="head">
                    公众号提醒列表：

                    <el-button
                    v-if="!addController"
                    class="btn-add" 
                    type="text"
                    @click="addController = true"
                    >
                        添加
                    </el-button>
                </div>

                <ul class="info-list">
                    <li 
                    v-for="(item, index) in tableData"
                    :key="index"
                    class="info-item" 
                    >
                        <div class="time">
                            {{item.send_time}}
                        </div>

                        <div class="title">
                            {{item.dw_code}}
                        </div>
                    </li>

                    <div
                    v-if="!tableData.length" 
                    class="empty"
                    >
                        无消息
                    </div>
                </ul>
            </div>
        </div>

        <slot slot="reference"></slot>
    </el-popover>
</template>

<script>
import FormAdd from './components/form-add';

export default {
    components: {
        FormAdd,
    },
    data() {
        return {
            showController: false,                          // popover显隐控制器

            tableData: [],                                  // 列表内容

            title: window._config.title2,                   // 平台名称
            qrUrl: `${window._config.rely}/weixin.jpg`,     // 二维码地址

            addController: false,                           // 添加控制器
            noFollowController: false,                      // 未关注公众号控制器
        };
    },
    methods: {
        queryData() {
            this.$get(`${this.getGetters('mngUrl')}/v2/notice/get_list.json`, {
                pageindex: 1,
                pagesize: 99,
                sortorder: 'desc',
                sortname: 'send_timing',
            }, data => {
                this.tableData = data.rows;
            });
        },
    },
    mounted() {
        this.queryData();
    },
};
</script>

<style lang="scss" scoped>
    @import '@/css/var.scss';

    .con{
        overflow: hidden;
        height: 310px;
        position: relative;

        .btn-close{
            position: absolute;
            right: 4px;
            top: 4px;
            cursor: pointer;
            z-index: 1;

            &:hover{
                color: #AB6BBD;
            }
        }

        .left{
            padding: 12px;
            margin-right: 390px;

            .head{
                font-size: 16px;
                font-weight: bold;
                color: #333;
                line-height: 1em;
                margin-bottom: 10px;
                cursor: default;
                overflow: hidden;

                .btn-add{
                    padding: 0;
                    float: right;
                }
            }

            .info-list{
                height: 224px;
                overflow-x: hidden;
                overflow-y: auto;
                position: relative;

                .info-item{
                    overflow: hidden;
                    line-height: 2em;
                    cursor: default;

                    .title{
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                        margin-right: 11em;
                    }

                    .time{
                        float: right;
                        margin-left: -11em;
                    }
                }

                .empty{
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    color: #999;
                }
            }
        }

        .right{
            width: 377px;
            height: 100%;
            float: right;
            position: relative;
            margin-left: -400px;

            &:before{
                content: '';
                display: block;
                width: 2px;
                height: 100%;
                background: #f0f2f5;
                position: absolute;
                left: 0;
                top: 0;
            }

            .center{
                width: 230px;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);

                .warn-text{
                    margin-bottom: 12px;
                    cursor: default;

                    .warn{
                        color: $warningColor;
                    }
                }

                .qrcode{
                    width: 172px;
                    height: 172px;
                    margin: 0 auto;

                    img{
                        display: block;
                        width: 100%;
                        height: 100%;
                    }
                }

                .qr-text{
                    text-align: center;
                    color: #333333;
                    line-height: 24px;
                    margin-top: 12px;
                    cursor: default;
                }
            }
        }
    }
</style>